/* global gtag */
import React, { useState,useEffect,useRef } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft,faPlus, faMinus, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import SortingArrows from './images/SortingArrows.png';
import Slider from './images/Slider.png';
import CartBag from './images/CartBag.png';
import ArrowLeft from './images/ArrowLeft.png';
import Microphone from './images/Microphone.png';
import Search from './images/Search.png';
import BucketEmptyConfirmPopup from './Component/BucketEmptyConfirmPopup';
import ViewBucket from './Component/ViewBucket';
import VoiceSearchModal from './Component/VoiceSearchModal';

const ProductList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
    const location = useLocation();
const { categoryId, categoryName, subcategoryId, subcategoryName,projectId } = location.state || {};console.log("Received category ID:", categoryId);
const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
const [subcategories, setSubcategories] = useState([]);
const [activeSubcategoryId, setActiveSubcategoryId] = useState(null);
const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
const [products, setProducts] = useState([]);
const [quantities, setQuantities] = useState({});

const bucketRef = useRef(null);
const imgRefs = useRef({});

const [showSort, setShowSort] = useState(false);
const [sortOption, setSortOption] = useState("default");
const [showFilter, setShowFilter] = useState(false);
const [selectedBrand, setSelectedBrand] = useState("");
const [activeFilterTab, setActiveFilterTab] = useState("price");
const [bucketImages, setBucketImages] = useState({});
const [allCategories, setAllCategories] = useState([]);
const [currentCategoryId, setCurrentCategoryId] = useState(categoryId);
const [currentCategoryName, setCurrentCategoryName] = useState(categoryName);
const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
const categoryDropdownRef = useRef(null);
const [bucketProducts, setBucketProducts] = useState({});
const [showVoiceModal, setShowVoiceModal] = useState(false);
const [showEmptyBucketPopup, setShowEmptyBucketPopup] = useState(false);
const [pendingRemoveProductId, setPendingRemoveProductId] = useState(null);
const [loading, setLoading] = useState(true);
const userData = JSON.parse(localStorage.getItem('userData')) || null;

useEffect(() => {
  fetchAllCategories();
  fetchAllSubcategories();
  fetchProductsByCategory(currentCategoryId);
}, [currentCategoryId]);


const handleVoiceSearch = () => {
  setShowVoiceModal(true);
};

const handleVoiceResult = (transcript) => {
  setSearchTerm(transcript);
};





useEffect(() => {
  const handleClickOutside = (event) => {
    if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
      setShowCategoryDropdown(false);
    }
  };

  if (showCategoryDropdown) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showCategoryDropdown]);


useEffect(() => {
  const savedBucketProducts = localStorage.getItem('bucketProducts');

  if (savedBucketProducts) {
    const products = JSON.parse(savedBucketProducts);
    setBucketProducts(products);

    // Build quantities from product data
    const quantities = {};
    const images = {};

    Object.values(products).forEach(product => {
      if (product._id) {
        quantities[product._id] = product.quantity || 0;
        if (product.product_image) {
          images[product._id] = true; // or store actual image path if needed
        }
      }
    });

    setQuantities(quantities);
    setBucketImages(images);
  } else {
    setBucketProducts({});
    setQuantities({});
    setBucketImages({});
  }
}, []);


useEffect(() => {
  if (subcategories.length > 0) {
    if (subcategoryId && subcategories.find(sub => sub._id === subcategoryId)) {
      setActiveSubcategoryId(subcategoryId);
    } else if (!activeSubcategoryId) {
      setActiveSubcategoryId(subcategories[0]._id);
    }
  }
}, [subcategories, subcategoryId]);


  const fetchAllSubcategories = async () => {
  if (!currentCategoryId) return;
  try {
    setLoading(true);
    const token = sessionStorage.getItem('token');
    const response = await fetch(
      `${fetchUrl}product-sub-category/get-productSubCategories-by-productCategoryId?product_category_id=${currentCategoryId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    const data = await response.json();
    console.log('Filtered subcategories data:', data);
    if (data.success) {
      setSubcategories(data.data || []);
      // Reset active subcategory when category changes
      setActiveSubcategoryId(null);
    } else {
      console.error('Failed to fetch subcategories:', data.message);
    }
  } catch (error) {
    console.error('Error fetching subcategories:', error);
  }
  finally {
    setLoading(false);
  }
};


const addRecentlyViewed = async (product) => {
  try {
    setLoading(true);
    const customerId = sessionStorage.getItem("customerId");
    const token = sessionStorage.getItem("token");

    if (!customerId || !token) return;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/add-recently-viewed`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          customerId,
          productId: product._id,
          name: product.product_name,
          image: product.product_image,
          price: product.selling_price,
       product_description: product.product_description || "",
  specifications: product.specifications || "[]",
        }),
      }
    );
console.log("Request body:", {
      customerId,
      productId: product._id,
      name: product.product_name,
      image: product.product_image,
      price: product.selling_price,
 product_description: product.product_description || "",
   specifications: product.specifications || "[]",
    });
    const data = await response.json();
    console.log("✅ Added to Recently Viewed:", data);
  } catch (err) {
    console.error("❌ Error adding recently viewed:", err);
  }
  finally {
    setLoading(false);
  }
};


const fetchAllCategories = async () => {
  try {
    setLoading(true);
    const response = await fetch(fetchUrl + "product-category/get-all-productCategories?is_ecommerce=true", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    const data = await response.json();
    console.log('Fetched all categories:', data);
    
    if (data.success) {
      setAllCategories(data.data);
    } else {
      console.error('Failed to fetch categories:', data.message);
    }
  } catch (error) {
    console.error('Error fetching categories:', error);
  }
  finally {
    setLoading(false);
  }
};


const fetchProductsByCategory = async (categoryId) => {
  try {
    setLoading(true);
    const token = sessionStorage.getItem('token');
    const response = await fetch(
      `${fetchUrl}product/get-products-by-category?product_category_id=${categoryId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    const data = await response.json();
    console.log("Fetched products data:", data);
    if (data.success) {
      console.log("Products fetched:", data.data);
      setProducts(data.data || []);
    } else {
      console.error("Failed to fetch products:", data.message);
    }
  } catch (error) {
    console.error("Error fetching products:", error);
  }
  finally {
    setLoading(false);
  }
};


const handleQuantityChange = (productId, action) => {
  // Always parse localStorage safely
  const currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');

  if (action === 'increase') {
    setQuantities(prev => {
      const newQty = (prev[productId] || 0) + 1;
      const newQuantities = { ...prev, [productId]: newQty };

      // Dispatch custom event to notify MenuFooter
      window.dispatchEvent(new CustomEvent('bucketUpdated'));

      // Find product
      const product = products.find(p => p._id === productId);
      if (product) {
        currentBucketProducts[productId] = {
          ...product,
          quantity: newQty,
        };

        localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
        setBucketProducts({ ...currentBucketProducts });
      }

      return newQuantities;
    });

    // Flying animation → only if first time adding
    if (!bucketImages[productId]) {
      setTimeout(() => {
        const imgEl = imgRefs.current?.[productId];
        const bucketEl = bucketRef.current;
        if (imgEl && bucketEl) {
          const fromRect = imgEl.getBoundingClientRect();
          const toRect = bucketEl.getBoundingClientRect();

          const flyingImg = document.createElement('img');
          flyingImg.src = `${imageUrl}${products.find(p => p._id === productId)?.product_image || ''}`;
          flyingImg.className =
            'fixed z-50 w-12 h-12 object-contain bg-white rounded-full shadow-xl border-2 border-red-400 pointer-events-none';
          flyingImg.style.top = `${fromRect.top + fromRect.height / 2 - 24}px`;
          flyingImg.style.left = `${fromRect.left + fromRect.width / 2 - 24}px`;
          flyingImg.style.transition = 'all 0.9s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          flyingImg.style.zIndex = '9999';

          document.body.appendChild(flyingImg);

          // Animate movement
          setTimeout(() => {
            flyingImg.style.top = `${toRect.top + toRect.height / 2 - 12}px`;
            flyingImg.style.left = `${toRect.left + toRect.width / 2 - 12}px`;
            flyingImg.style.transform = 'scale(0.5)';
            flyingImg.style.opacity = '0.3';
          }, 100);

          // Cleanup & update bucketImages
          setTimeout(() => {
            setBucketImages(prev => {
              const newBucketImages = { ...prev, [productId]: true };
             // localStorage.setItem('bucketImages', JSON.stringify(newBucketImages));
              return newBucketImages;
            });

            if (document.body.contains(flyingImg)) {
              document.body.removeChild(flyingImg);
            }
          }, 1000);
        }
      }, 100);
    }
  } 
  
  else if (action === 'decrease') {
    const currentQty = quantities[productId] || 0;
    const totalItemsInBucket = Object.values(quantities).reduce((total, qty) => total + qty, 0);

    if (currentQty === 1 && totalItemsInBucket === 1) {
      // Last item in bucket → confirmation popup
      setPendingRemoveProductId(productId);
      setShowEmptyBucketPopup(true);
      return;
    }else{
    performDecrease(productId);
    }

  }
};

const handleMainProductQuantityInputChange = (productid, value) => {
  // Parse value as number (handles string from input) and default to 1 if falsy, <=0, or <1
  const parsedValue = parseInt(value, 10) || 0; // Parse to int, default to 0 if invalid/empty
  const effectiveValue = parsedValue < 1 ? 1 : parsedValue; // If <1 (including 0, negative, or invalid), set to 1

  // Parse current bucket from localStorage
  const currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
  const mainProductId = productid

  // Find the main product (adjust based on your data source, e.g., relatedProducts or a separate mainProduct)
  const productData = currentBucketProducts[mainProductId]; // Use mainProduct if separate

  if (productData) {
    // Always update/add the product in the bucket with the effective quantity (no deletion, just change quantity)
    currentBucketProducts[mainProductId] = {
      ...productData,
      quantity: effectiveValue,
    };
    const quantitiesData = quantities
          quantitiesData[mainProductId] = effectiveValue

          setQuantities(quantitiesData)

    // Persist to localStorage and update state
    localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
    setBucketProducts({ ...currentBucketProducts });

    // Dispatch the event after the bucket has been updated
    window.dispatchEvent(new CustomEvent('bucketUpdated'));
  }
};

const performDecrease = (productId) => {
  const currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');

  setQuantities(prev => {
    const newQty = Math.max(0, (prev[productId] || 1) - 1);
    const newQuantities = { ...prev, [productId]: newQty };

    // Update or remove product
    if (currentBucketProducts[productId]) {
      if (newQty > 0) {
        currentBucketProducts[productId] = {
          ...currentBucketProducts[productId],
          quantity: newQty,
        };
      } else {
        delete currentBucketProducts[productId];
      }
      localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
      setBucketProducts({ ...currentBucketProducts });
    }

    // Notify MenuFooter
    window.dispatchEvent(new CustomEvent('bucketUpdated'));

    return newQuantities;
  });
};


const handleConfirm = () => {
  if (pendingRemoveProductId) {
    performDecrease(pendingRemoveProductId);
  }
  setShowEmptyBucketPopup(false);
  setPendingRemoveProductId(null);
};


const handleCategorySelect = (category) => {
  setCurrentCategoryId(category._id);
  setCurrentCategoryName(category.product_category_name);
  setShowCategoryDropdown(false);
  setSearchTerm('');
  
};

if (loading) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
      {/* 🔴 Red spinning circle */}
      <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Text below loader */}
      <p className="mt-4 text-gray-400 text-xs">Loading Products...</p>
    </div>
  );
}

 const handleViewBucket = () => {
    navigate('/consumer/cartpreview', { state: { projectId } });
  };

const getSortedProducts = () => {
  const filtered = products.filter(p =>
    p.product_sub_category_id === activeSubcategoryId &&
    p.product_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  switch (sortOption) {
    case "highToLow":
      return filtered.sort((a, b) => b.selling_price - a.selling_price);
    case "lowToHigh":
      return filtered.sort((a, b) => a.selling_price - b.selling_price);
    case "newest":
      return filtered.sort((a, b) => new Date(b.createdAt || b.created_at) - new Date(a.createdAt || a.created_at));
    case "relavance":
      return filtered;
    case "default":
      return filtered;
    default:
      return filtered;
  }
};



const filtered = products.filter(p =>
  p.product_sub_category_id === activeSubcategoryId &&
  p.product_name.toLowerCase().includes(searchTerm.toLowerCase()) &&
  (selectedBrand ? p.brand === selectedBrand : true)
);

  return (
  <div className="min-h-screen ">
    {/* Header */}
     <div className='border-b border-gray-300 mb-4'>
  <div className="px-2 bg-white py-3 flex justify-between items-center sticky top-0 z-30">
    <div className="flex items-center">
      <button onClick={() => navigate(-1)} className="text-gray-700 p-1 hover:bg-gray-100 rounded-md">
        <img 
          src={ArrowLeft} 
          alt="Back" 
          className="w-10 h-6" 
        />
      </button>
      <h2 className="text-sm font-medium text-[#000000]">Products</h2>
    </div>
  </div>
</div>

    {/* Category Title and Subcategory Tabs */}
{currentCategoryName && (
  <>
    <div className="px-6 py-2 bg-white border border-gray-300 rounded-md flex justify-between items-center cursor-pointer mx-6 mb-3 relative" ref={categoryDropdownRef}>
      <div 
        className="flex justify-between items-center w-full"
        onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
      >
        <div className="flex items-center space-x-3">
          {/* Current Category Image */}
          <div className="w-6 h-6 bg-[#F5F5F5] rounded-md flex items-center justify-center flex-shrink-0">
            {allCategories.find(cat => cat._id === currentCategoryId)?.product_category_image ? (
              <img
                src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${allCategories.find(cat => cat._id === currentCategoryId)?.product_category_image}`}
                alt={currentCategoryName}
                className="w-5 h-5 object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            ) : (
              <div className="w-5 h-5 bg-gray-200 rounded-sm"></div>
            )}
          </div>
          
          <h2 className="text-sm font-regular text-[#000000]">{currentCategoryName}</h2>
        </div>
        
        <FontAwesomeIcon 
          icon={faChevronDown} 
          className={`text-gray-500 text-sm transition-transform ${showCategoryDropdown ? 'rotate-180' : ''}`} 
        />
      </div>
      
      {/* Dropdown Menu */}
      {showCategoryDropdown && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-40 max-h-60 overflow-y-auto">
          {allCategories
            .filter(cat => cat._id !== currentCategoryId) // Exclude current category
            .map((category, index) => (
              <div key={category._id}>
                <div
                  className="px-4 py-3 hover:bg-gray-50 cursor-pointer flex items-center space-x-3"
                  onClick={() => handleCategorySelect(category)}
                >
                  {/* Category Image */}
                  <div className="w-8 h-8 bg-[#F5F5F5] rounded-md flex items-center justify-center flex-shrink-0">
                    {category.product_category_image ? (
                      <img
                        src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${category.product_category_image}`}
                        alt={category.product_category_name}
                        className="w-6 h-6 object-contain"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    ) : (
                      <div className="w-6 h-6 bg-gray-200 rounded-sm"></div>
                    )}
                  </div>
                  
                  {/* Category Name */}
                  <span className="text-sm text-[#000000] flex-1">
                    {category.product_category_name}
                  </span>
                </div>
                
                {/* Separator line (except for last item) */}
                {index < allCategories.filter(cat => cat._id !== currentCategoryId).length - 1 && (
                  <div className="border-b border-gray-100 mx-4"></div>
                )}
              </div>
            ))}
        </div>
      )}
    </div>

    {/* Subcategory Tabs */}
    <div className="overflow-x-auto whitespace-nowrap bg-white px-6 py-2" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
      <div className="flex space-x-3" style={{ overflow: 'visible' }}>
        {subcategories.map(sub => {
          const isActive = activeSubcategoryId === sub._id;
          return (
            <button
              key={sub._id}
              onClick={() => setActiveSubcategoryId(sub._id)}
              className={`flex flex-col items-center justify-center px-3 py-1 rounded-md min-w-[80px] flex-shrink-0 relative`}
            >
              {sub.product_sub_category_image ? (
                <img
                  src={`${imageUrl}${sub.product_sub_category_image}`}
                  alt={sub.product_sub_category_name}
                  className="w-10 h-14 object-contain mb-1"
                />
              ) : (
                <div className="w-10 h-14 mb-1" />
              )}
              <span className="text-xs text-gray-700 text-center line-clamp-2 leading-tight mb-1">
                {sub.product_sub_category_name}
              </span>
              {isActive && (
                <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-red-500 rounded-t-md" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  </>
)}


    {/* Search Bar */}
<div className="px-6 pt-6 pb-2 bg-white sticky top-0 z-20">
  <div className="relative max-w-xl mx-auto">
    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
      <img
        src={Search}
        alt="Search"
        className="h-6 w-6"
      />
    </span>
    <input
      type="text"
      placeholder='Search "product name or say it"'
      value={searchTerm}
      onChange={e => setSearchTerm(e.target.value)}
      className="w-full pl-12 pr-12 py-2 rounded-md border border-gray-300 text-sm font-medium focus:outline-none"
    />
    
  <button
  className="absolute inset-y-0 right-0 flex items-center pr-3"
  onClick={searchTerm ? () => setSearchTerm('') : handleVoiceSearch}
>

      {searchTerm ? (
        <div className="w-5 h-5 bg-gray-400 hover:bg-gray-500 rounded-full flex items-center justify-center transition-colors">
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
      ) : (
        <img
          src={Microphone}
          alt="Voice Search"
          className="w-6 h-8"
        />
      )}
    </button>
  </div>
</div>



    {/* Filters and Sorting */}
    <div className="bg-white ">
      <div className="px-4 py-3">
        <div className="flex justify-between items-center">
          <div className="text-sm text-gray-500"> </div>
          <div className="flex space-x-3">
  <button
    onClick={() => setShowFilter(true)}
    className="flex items-center space-x-1 px-2 py-1 bg-white border border-gray-300 rounded-md text-[#000000] text-xs"
  >              <img src={Slider} className="w-4 h-4 text-[#E0D9D9]" alt="Filter" />
              <span>Filters</span>
            </button>
 <button
    onClick={() => setShowSort(true)}
    className="flex items-center space-x-1 px-3 py-1 bg-white border border-gray-300  rounded-md text-[#000000]  text-xs"
  >              <img src={SortingArrows} className="w-4 h-4 text-gray-500" alt="Sort" />
              <span>Sort</span>
            </button>
          </div>
        </div>
      </div>
    </div>

{/* Filtered Products */} 
<div className="px-6 py-4 pb-10 bg-white">
  {getSortedProducts().length > 0 ? (
    <div className="bg-white">
      <div className="grid grid-cols-2 gap-4">
        {getSortedProducts().map(product => {
          const quantity = quantities[product._id] || 0;
          return (
            <div key={product._id} className="flex flex-col">
              {/* Your existing product card JSX - keep unchanged */}
              <div className="rounded-xl bg-[#F5F5F5] overflow-hidden mb-3 relative pb-12 mx-1">
        <div className="h-24 flex items-center justify-center p-3">
  {product.product_image ? (
    <img
      ref={(el) => (imgRefs.current[product._id] = el)}
      src={`${imageUrl}${product.product_image}`}
      alt={product.product_name}
      className="h-full w-full object-contain cursor-pointer hover:scale-105 transition-transform duration-200"
      onClick={() => {
         /*  gtag('event', 'product_click', {
  brand_id: product.vendor_id.toString(),
  brand_name: product.vendor_name || '',
  product_id: product._id.toString(),
  product_name: product.product_name,
  page_location: window.location.href,
  page_path: window.location.pathname,
  user_id: userData._id || null,
  timestamp: new Date().toISOString()
}); */
        addRecentlyViewed(product);
        navigate('/consumer/productInformation', {
          state: {
            product: product,
            relatedProducts: getSortedProducts(),
            categoryId: categoryId,
            categoryName: categoryName,
            subcategoryId: activeSubcategoryId,
            vendor_id: product.vendor_id,
          },
        });
      }}
    />
  ) : (
    <div
      className="h-full w-full flex items-center justify-center text-center text-gray-500 text-sm cursor-pointer"
      onClick={() => {
        addRecentlyViewed(product);
        navigate('/consumer/productInformation', {
          state: {
            product: product,
            relatedProducts: getSortedProducts(),
            categoryId: categoryId,
            categoryName: categoryName,
            subcategoryId: activeSubcategoryId,
            vendor_id: product.vendor_id,
          },
        });
      }}
    >
      {product.product_name}
    </div>
  )}
</div>


                                                 
                <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2">
                  {quantity === 0 ? (
                    <button
                      onClick={() => handleQuantityChange(product._id, 'increase')}
                      className="text-xs text-[#D93025] bg-white border border-red-500 rounded-md px-6 py-1 font-semibold hover:bg-red-50 transition shadow-sm"
                    >
                      Add
                    </button>
                  ) : (
                    <>

                       <div className="flex items-center justify-between bg-white border border-red-500 rounded-md px-2 py-1 shadow-sm">
  <button
   onClick={() => handleQuantityChange(product._id, 'decrease')}
    className="w-5 h-5 flex items-center justify-center text-red-500 text-sm font-bold disabled:opacity-50 disabled:cursor-not-allowed"
  >
    −
  </button>
  <input
    type="number"
    value={quantity}
    onChange={(e) => handleMainProductQuantityInputChange(product._id, e.target.value)} // New handler for direct input changes
    onFocus={(e) => {
      e.target.select(); // Select all text on focus for easy editing
    }}
    onBlur={(e) => {
      // Optional: Ensure value is at least 1 on blur (if needed, but handler already enforces this)
    }}
    min="1"
    className="w-10 text-center text-sm text-gray-900 font-medium border-0 bg-transparent focus:outline-none focus:ring-0 focus:border-transparent mx-1 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
    placeholder="1"
  />
  <button
    onClick={() => handleQuantityChange(product._id, 'increase')}
    className="w-5 h-5 flex items-center justify-center text-red-500 text-sm font-bold"
  >
    +
  </button>
</div>

{/* 
                    <div className="flex items-center justify-between bg-white border border-red-500 rounded-md px-3 py-1 shadow-sm">
                      <button
                        onClick={() => handleQuantityChange(product._id, 'decrease')}
                        className="w-5 h-5 flex items-center justify-center text-red-500 text-sm font-bold"
                      >
                        −
                      </button>
                      <span className="text-sm text-gray-900 font-medium mx-3">{quantity}</span>
                      <button
                        onClick={() => handleQuantityChange(product._id, 'increase')}
                        className="w-5 h-5 flex items-center justify-center text-red-500 text-sm font-bold"
                      >
                        +
                      </button>
                    </div> */}
                    </>
                  )}
                </div>
              </div>

              <div className="flex flex-col items-start mx-1">
                <h3 className="text-xs font-medium text-[#000000] mb-1 line-clamp-2 leading-snug text-left">
                  {product.product_name}
                </h3>
                <p className="text-xs text-[#170101] font-semibold">
                  ₹{product.selling_price.toLocaleString()}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  ) : (
    <div className="flex flex-col items-center justify-start mt-6 px-4">
      <img
        src={CartBag}
        alt="No products found"
        className="w-24 h-24 object-contain mb-1 opacity-60"
      />
      <h3 className="text-center text-xl font-semibold text-gray-600 mb-1">Sorry!</h3>
      <div className="text-center text-gray-500 text-sm">
        {searchTerm ?
          `Currently we don't have "${searchTerm}" available with us.` :
          'No products available in this category.'
        }
      </div>
    </div>
  )}
</div>



      <ViewBucket
        bucketProducts={bucketProducts}
        imageUrl={imageUrl}
        bucketRef={bucketRef}
        onViewBucket={handleViewBucket}
      />


{/*section end*/}



{showSort && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end">
    <div className="bg-white w-full rounded-t-2xl relative">
      {/* Close button */}
      <button 
        onClick={() => setShowSort(false)}
        className="absolute -top-12 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-black bg-opacity-70 rounded-full flex items-center justify-center text-white text-2xl font-bold"
      >
        ×
      </button>
      
      <div className="p-6">
        <div className="border-b pb-3 mb-4">
          <h3 className="text-xl font-semibold text-gray-800">Sort By</h3>
        </div>

        <div className="space-y-4">
          <label className="flex items-center space-x-3 cursor-pointer">
            <input 
              type="radio" 
              name="sort" 
              value="relavance" 
              checked={sortOption === "default" || sortOption === "relavance"}
              onChange={(e) => {
                setSortOption(e.target.value);
                setShowSort(false);
              }}
              className="w-5 h-5 accent-red-500" 
            />
            <span className="text-lg text-gray-800">Relevance (Default)</span>
          </label>
          
          <label className="flex items-center space-x-3 cursor-pointer">
            <input 
              type="radio" 
              name="sort" 
              value="newest" 
              checked={sortOption === "newest"}
              onChange={(e) => {
                setSortOption(e.target.value);
                setShowSort(false);
              }}
              className="w-5 h-5 accent-red-500" 
            />
            <span className="text-lg text-gray-800">Newest</span>
          </label>
          
          <label className="flex items-center space-x-3 cursor-pointer">
            <input 
              type="radio" 
              name="sort" 
              value="highToLow" 
              checked={sortOption === "highToLow"}
              onChange={(e) => {
                setSortOption(e.target.value);
                setShowSort(false);
              }}
              className="w-5 h-5 accent-red-500" 
            />
            <span className="text-lg text-gray-800">Price: High to Low</span>
          </label>
          
          <label className="flex items-center space-x-3 cursor-pointer">
            <input 
              type="radio" 
              name="sort" 
              value="lowToHigh" 
              checked={sortOption === "lowToHigh"}
              onChange={(e) => {
                setSortOption(e.target.value);
                setShowSort(false);
              }}
              className="w-5 h-5 accent-[#D93025]" 
            />
            <span className="text-lg text-gray-800">Price: Low to High</span>
          </label>
        </div>
      </div>
    </div>
  </div>
)}

{showFilter && (
  <div className="fixed inset-0 bg-black bg-opacity-60 z-50">
    <div className="bg-white h-full w-full flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-4 border-b border-gray-200 bg-white">
        <button 
          onClick={() => setShowFilter(false)}
          className="p-2"
        >
          <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
        <button 
          className="text-[#D93025] font-medium text-sm"
          onClick={() => {
            setSelectedBrand("");
            setActiveFilterTab("sort");
          }}
        >
          CLEAR ALL
        </button>
      </div>

      {/* Main Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar - 30% */}
        <div className="w-[36%] bg-gray-50 border-r border-gray-200 overflow-y-auto">
          <div className="py-2">
            {[
              { id: "price", label: "Price", icon: "₹" },
              { id: "brand", label: "Brand", icon: "🏷️" },
              { id: "rating", label: "Rating", icon: "⭐" },
              { id: "availability", label: "Availability", icon: "📦" },
              { id: "discount", label: "Discount", icon: "🏷️" }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveFilterTab(tab.id)}
                className={`w-full text-left px-4 py-4 border-b border-gray-200 flex items-center space-x-3 ${
                  activeFilterTab === tab.id 
                    ? 'bg-white border-r-2 border-r-[#D93025] text-[#D93025]' 
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <span className="text-lg">{tab.icon}</span>
                <span className="text-sm font-medium">{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Vertical Divider */}
        <div className="w-px bg-gray-200"></div>

        {/* Right Content Area - 70% */}
        <div className="flex-1 bg-white overflow-y-auto">
          <div className="p-4">
            
            {/* Sort Content */}
            {/* {activeFilterTab === "sort" && (
              <div className="space-y-3">
                <h4 className="text-base font-medium text-gray-900 mb-4">Sort by</h4>
                {[
                  { label: "Relevance", value: "relevance" },
                  { label: "Price: Low to High", value: "lowToHigh" },
                  { label: "Price: High to Low", value: "highToLow" },
                  { label: "Newest First", value: "newest" }
                ].map((item, index) => (
                  <label key={index} className="flex items-center space-x-3 cursor-pointer py-2">
                    <input 
                      type="radio" 
                      name="sort" 
                      value={item.value}
                      checked={sortOption === item.value}
                      onChange={(e) => setSortOption(e.target.value)}
                      className="w-4 h-4 text-green-500 accent-green-500" 
                    />
                    <span className="text-sm text-gray-700">{item.label}</span>
                  </label>
                ))}
              </div>
            )} */}

            {/* Price Content */}
            {activeFilterTab === "price" && (
              <div className="space-y-3">
                <h4 className="text-base font-medium text-gray-900 mb-4">Price Range</h4>
                {[
                  "Under ₹100",
                  "₹100 - ₹500", 
                  "₹500 - ₹1000",
                  "₹1000 - ₹2000",
                  "Above ₹2000"
                ].map((price, index) => (
                  <label key={index} className="flex items-center space-x-3 cursor-pointer py-2">
                    <input type="checkbox" className="w-4 h-4 accent-[#D93025] rounded" />
                    <span className="text-sm text-gray-700">{price}</span>
                  </label>
                ))}
              </div>
            )}

            {/* Brand Content */}
            {activeFilterTab === "brand" && (
              <div className="space-y-3">
                <h4 className="text-base font-medium text-gray-900 mb-4">Select Brand</h4>
                {[
                  "Asian Paints",
                  "Berger Paints", 
                  "Dulux",
                  "Nerolac",
                  "Kansai Nerolac",
                  "Indigo Paints"
                ].map((brand, index) => (
                  <label key={index} className="flex items-center space-x-3 cursor-pointer py-2">
                    <input 
                      type="checkbox" 
                      className="w-4 h-4 accent-[#D93025] rounded"
                      checked={selectedBrand === brand}
                      onChange={() => setSelectedBrand(selectedBrand === brand ? "" : brand)}
                    />
                    <span className="text-sm text-gray-700">{brand}</span>
                  </label>
                ))}
              </div>
            )}

            {/* Rating Content */}
            {activeFilterTab === "rating" && (
              <div className="space-y-3">
                <h4 className="text-base font-medium text-gray-900 mb-4">Customer Rating</h4>
                {[
                  "4★ & above",
                  "3★ & above", 
                  "2★ & above",
                  "1★ & above"
                ].map((rating, index) => (
                  <label key={index} className="flex items-center space-x-3 cursor-pointer py-2">
                    <input type="checkbox" className="w-4 h-4 accent-[#D93025] rounded" />
                    <span className="text-sm text-gray-700">{rating}</span>
                  </label>
                ))}
              </div>
            )}

            {/* Availability Content */}
            {activeFilterTab === "availability" && (
              <div className="space-y-3">
                <h4 className="text-base font-medium text-gray-900 mb-4">Availability</h4>
                {[
                  "In Stock",
                  "Fast Delivery",
                  "Same Day Delivery",
                  "Express Delivery"
                ].map((item, index) => (
                  <label key={index} className="flex items-center space-x-3 cursor-pointer py-2">
                    <input type="checkbox" className="w-4 h-4 accent-[#D93025] rounded" />
                    <span className="text-sm text-gray-700">{item}</span>
                  </label>
                ))}
              </div>
            )}

            {/* Discount Content */}
            {activeFilterTab === "discount" && (
              <div className="space-y-3">
                <h4 className="text-base font-medium text-gray-900 mb-4">Discount</h4>
                {[
                  "10% & above",
                  "20% & above",
                  "30% & above",
                  "50% & above"
                ].map((discount, index) => (
                  <label key={index} className="flex items-center space-x-3 cursor-pointer py-2">
                    <input type="checkbox" className="w-4 h-4 accent-[#D93025] rounded" />
                    <span className="text-sm text-gray-700">{discount}</span>
                  </label>
                ))}
              </div>
            )}

          </div>
        </div>
      </div>

      {/* Bottom Apply Button */}
      <div className="px-4 py-4 bg-white border-t border-gray-200">
        <button
          className="w-full bg-[#D93025] text-white py-3 rounded-lg font-medium text-base"
          onClick={() => setShowFilter(false)}
        >
          APPLY FILTERS
        </button>
      </div>
    </div>
  </div>
)}


<BucketEmptyConfirmPopup
  isOpen={showEmptyBucketPopup}
  onClose={() => {
    setShowEmptyBucketPopup(false);
    setPendingRemoveProductId(null);
  }}
  onConfirm={handleConfirm}
  productName={
    pendingRemoveProductId 
      ? products.find(p => p._id === pendingRemoveProductId)?.product_name || "this item"
      : "this item"
  }
/>

<VoiceSearchModal
  isOpen={showVoiceModal}
  onClose={() => setShowVoiceModal(false)}
  onResult={handleVoiceResult}
/>



  </div> 
);

};

export default ProductList;
